// import Firebase from 'firebase/app'
// import { storage } from '../firebase-app'
// import ImageLib from './image'

/**
 * @typedef {{w:number, h:number}} Dimensions
 *
 * @typedef {{
 *  raw?: HTMLCanvasElement
 *  blob?: Blob
 *  dimensions: Dimensions
 *  url: string
 * }} ImageData
 *
 * @typedef {Object<string, ImageData>} ImageSizeTypes
 *
 * @typedef {ImageSizeTypes & {
 *  order: number
 *  caption: string
 * }} PostImageData
 *
 *
 * @typedef {PostImageData? & {
 *  id?: string
 *  delited?: boolean
 * }} ImageAttachment
 *
 *
 * @typedef {*? & {
 *  file: Blob|File
 *  image?: HTMLImageElement
 * }} Attachment
 *
 *
 * @typedef {{
 *  sizeType: string
 *  blob: Blob
 *  name: string
 *  dimensions: Dimensions
 *  attachment: Attachment
 *  }} UploadStruct
 *
 * @typedef {{
 *  uploadData: UploadStruct
 *  url: string
 * }} UploadedFileData
 */

export function bytesToString (bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

// const imageSizeTypes = { full: 2048, preview: 512 }
//
// const mimeExtension = {
//   'image/gif': 'gif',
//   'image/jpeg': 'jpg',
//   'image/png': 'png',
//   'application/pdf': 'pdf',
//   'application/msword': 'doc',
//   'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
//   'audio/mpeg': 'mp3',
//   'audio/mp4': 'm4a',
//   'video/mp4': 'mp4',
//   'video/quicktime': 'mov'
// }

/**
 * @return {string}
 */
export function uniqueId () {
  return Date.now().toString().substr(-7) + Math.random().toString(36).substr(2, 9) + Math.random().toString(36).substr(2, 9)
}

/**
 * @param {Blob} blob
 * @param {string} name
 * @param {string} sizeType
 * @param {Dimensions} dimensions
 * @param {Object} attachment
 * @return {UploadStruct}
 */
export function uploadStruct (blob, name, sizeType, dimensions, attachment) {
  return { blob, name, sizeType, dimensions, attachment }
}

/**
 * @param {string} path
 * @param {UploadStruct} uploadStruct
 * @param {function(string, number): void} progressFn
 * @return {Promise<UploadedFileData>}
 */
// function put (path, uploadStruct, progressFn) {
//   const uploadTask = storage.ref(path).put(uploadStruct.blob, { contentType: uploadStruct.blob.type })
//   return new Promise((resolve, reject) => {
//     uploadTask.on(Firebase.storage.TaskEvent.STATE_CHANGED,
//       snapshot => {
//         const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
//         // console.log('Upload is ' + progress + '% done')
//         if (progressFn) {
//           progressFn(uploadStruct.attachment.id, progress)
//         }
//         switch (snapshot.state) {
//           case Firebase.storage.TaskState.PAUSED:
//             // console.log('Upload is paused')
//             break
//           case Firebase.storage.TaskState.RUNNING:
//             // console.log('Upload is running')
//             break
//         }
//       },
//       error => reject(error),
//       () => resolve(uploadTask.snapshot))
//   }).then(snapshot => {
//     // console.log('New pic uploaded. Size:', snapshot.totalBytes, 'bytes.')
//     return snapshot.ref.getDownloadURL().then(url => {
//       // console.log('File available at', url)
//       return { uploadData: uploadStruct, url }
//     })
//   })
// }

/**
 * @param {string} userId
 * @param {string} workId
 * @param {File[]} files
 * @param {function(string, number): void} progressFn
 * @return {Promise<Object<string, PostImageData> | never>}
 */
export function uploadWorkSourceFiles (userId, workId, files, progressFn) {
}
